export const API_CONFIG = {
  BASE_URL: "https://enjazsvu.runasp.net/api",
  ENDPOINTS: {
    AUTH: {
      LOGIN: "/Auth/login",
      LOGOUT: "/Auth/logout",
      REFRESH: "/Auth/newrefreshtoken",
      CONFIRM_OTP: "/Auth/confirmOtp",
      FORGET_PASSWORD: "/Auth/forgetPassword",
      RESET_PASSWORD: "/Auth/resetPassword",
    },
    ACHIEVEMENTS: {
      LIST: "/Achievement/allAchievements",
      CREATE: "/Achievement/CreateAchievement",
      UPDATE: "/Achievement/update/{id}",
      VIEW: "/Achievement/view/{id}",
      DELETE: "/Achievement/delete",
    },
    USER_ACHIEVEMENTS: {
      LIST: "/UserAchievements/UserAchievements",
      ASSIGN: "/UserAchievements/assign",
      UNASSIGN: "/UserAchievements/UnAssignUsers",
      SUBMIT: "/UserAchievements/SubmitAchievement",
      UPDATE: "/UserAchievements/UpdateUserAchievement",
      REQUEST_EDIT: "/Achievement/request-edit",
      GET_USERS: "/Achievement/AchievementUsers",
    },
    REQUEST_EDIT: {
      SEND_REQUEST: "/Request/SendRequest",
    },
    USERS: {
      LIST: "/User/view",
      SEARCH: "/users/search",
      CREATE: "/Auth/register",
      BULK_DELETE: "/User/bulkDelete",
      SEND_CREDENTIALS: "/User/sendEmail",
    },
    USER: {
      PROFILE: "/user/profile",
      UPDATE: "/User/update",
      USER_ACHIEVEMENTS: "/user/achievements",
    },
    EVALUATOR: {
    },
    FACULTIES: {
      GET_ALL: "/Faculty/GetAllFaculties",
    },
  },
} as const
